import { createAuthClient } from "better-auth/react";
import { API_BASE } from "./api";
import { getToken, isNative, setToken } from "./native";
import { LANG } from "@shared/i18n";

export const authClient = createAuthClient({
  baseURL: `${API_BASE || window.location.origin}/api/auth`,
  fetchOptions: {
    credentials: "include",
    headers: { "X-Lang": LANG },
    ...(isNative
      ? {
          auth: { type: "Bearer", token: () => getToken() ?? "" },
          onSuccess: (ctx) => {
            const token = ctx.response.headers.get("set-auth-token");
            if (token) void setToken(token);
          },
        }
      : {}),
  },
});

export async function signOut() {
  await authClient.signOut();
  await setToken(null);
}
